import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { State } from "country-state-city";
import ImageUploads from "../util/ImageUploads";
import BannerImagesUploads from "../util/BannerImagesUploads";
import InputMask from "react-input-mask";
import { authCall } from "../../services";

const BREACKFASTDAYS = {
  Monday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
  Tuesday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
  Wednesday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
  Thursday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
  Friday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
  Saturday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
  Sunday: {
    openningTime: "06:00",
    closingTime: "11:00",
    close: false,
  },
};

const LUNCHDAYS = {
  Monday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
  Tuesday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
  Wednesday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
  Thursday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
  Friday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
  Saturday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
  Sunday: {
    openningTime: "11:00",
    closingTime: "16:00",
    close: false,
  },
};

const DINNERDAYS = {
  Monday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
  Tuesday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
  Wednesday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
  Thursday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
  Friday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
  Saturday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
  Sunday: {
    openningTime: "16:00",
    closingTime: "22:00",
    close: false,
  },
};

const ALLDAYS = {
  Monday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
  Tuesday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
  Wednesday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
  Thursday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
  Friday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
  Saturday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
  Sunday: {
    openningTime: "06:00",
    closingTime: "22:00",
    close: false,
  },
};

const DIETS = [
  "Vegetarian",
  "Vegan",
  "Nut Free",
  "Dairy Free",
  "Gluten",
  "Halal",
];

const RESTAURANTVALUES = ["$", "$$", "$$$", "$$$$"];

const PURPOSES = {
  Morning: {
    family: false,
    popular: false,
    meeting: false,
  },
  Midday: {
    family: false,
    popular: false,
    meeting: false,
  },
  Evening: {
    family: false,
    popular: false,
    meeting: false,
  },
  Late: {
    family: false,
    popular: false,
    meeting: false,
  },
};

const customStyles = {
  control: (provided) => ({
    ...provided,
    border: "1px solid var(--theme-dark1) !important;",
    color: "var(--black)",
    height: 40,
    fontSize: 16,
    borderRadius: "var(--bs-border-radius)",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

function RestaurantDetailPage({
  onSubmit,
  loading,
  details,
  heading,
  Sidebar,
  buttons,
}) {
  const { current } = useSelector((state) => state.user);
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const [states, setStates] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [mapLoading, setMapLoading] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [googleMapUrlError, setGoogleMapUrlError] = useState("");
  const [googleMapUrl, setGoogleMapUrl] = useState("");

  useEffect(() => {
    const data = State.getStatesOfCountry("AU");
    const options = data.map((s) => ({
      value: s.isoCode,
      label: s.name,
    }));
    setStates(options);
    console.log("options", options);
  }, []);

  const [profileImage, setProfileImage] = useState("");
  const [mapImage, setMapImage] = useState("");
  const [bannerImages, setBannerImages] = useState(details?.banners_path || []);

  const [isProfileImageChange, setIsProfileImageChange] = useState(false);
  const [isMapImageChange, setIsMapImageChange] = useState(false);
  const [isBannerImageChange, setIsBannerImageChange] = useState(false);

  const [openBreakfast, setOpenBreakfast] = useState(false);
  const [openLunch, setOpenLunch] = useState(false);
  const [openDinner, setOpenDinner] = useState(false);
  const [openAllDay, setOpenAllDay] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [purpose, setPurpose] = useState(false);

  const [values, setValues] = useState({
    restaurantId: "",
    locationId: "",
    name: "",
    phone: "",
    address: {
      streetName: "",
      city: "",
      state: "",
      zipCode: "",
    },
    overview: "",
    breakFastHours: BREACKFASTDAYS,
    lunchHours: LUNCHDAYS,
    dinnerHours: DINNERDAYS,
    allDayHours: ALLDAYS,
    bannerImageUploaded: details?.banners_path || "",
    totalRating: 0,
    userTotalRating: 0,
    dietaries: [],
    restaurantValue: "",
    // website: "",
    bookingUrl: "",
    purpose: PURPOSES,
  });

  useEffect(() => {
    setValues({
      ...values,
      restaurantId: details?.id || "",
      locationId: details?.google_place_id || "",
      name: details?.name || "",
      phone: details?.phone || "",
      address: {
        streetName: details?.restaurant_address?.streetName || "",
        city: details?.restaurant_address?.city || "",
        state: details?.restaurant_address?.state || "",
        zipCode: details?.restaurant_address?.zipCode || "",
      },
      latitude: details?.latitude || "",
      longitude: details?.longitude || "",
      overview: details?.overview || "",
      breakFastHours: details?.breakfast_hours || BREACKFASTDAYS,
      lunchHours: details?.lunch_hours || LUNCHDAYS,
      dinnerHours: details?.dinner_hours || DINNERDAYS,
      allDayHours: details?.same_hours_all_day || ALLDAYS,
      bannerImageUploaded: details?.banners_path || "",
      totalRating: details?.total_ratings || 0,
      userTotalRating: details?.user_ratings_total || 0,
      dietaries: details?.dietaries || [],
      restaurantValue: details?.restaurantValue || "",
      // website: details?.website || "",
      bookingUrl: details?.booking_url || "",
      purpose: details?.purposes || PURPOSES,
    });

    setProfileImage(details?.profile_image_path || "");
    setMapImage(details?.map_image_path || "");
    setBannerImages(details?.banners_path || []);

    setOpenBreakfast(details?.open_breakfast === "1" ? true : openBreakfast);
    setOpenLunch(details?.open_lunch === "1" ? true : openLunch);
    setOpenDinner(details?.open_dinner === "1" ? true : openDinner);
    setOpenAllDay(details?.open_allday === "1" ? true : openAllDay);
    setGoogleMapUrl(details?.map_image || googleMapUrl);
  }, [details]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setValues((prevValues) => ({
        ...prevValues,
        [parent]: {
          ...prevValues[parent],
          [child]: value,
        },
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }

    if (name === "phone" && value.length > 10) {
      setValues({ ...values, phone: value.slice(0, 10) });
    }

    if (name === "locationId") {
      setLocationError(false);
    }
  };

  const handleChangeHours = (day, field, value) => {
    setValues({
      ...values,
      breakFastHours: {
        ...values.breakFastHours,
        [day]: {
          ...values.breakFastHours[day],
          [field]: value,
        },
      },
    });
  };

  const handleChangeLunchHours = (day, field, value) => {
    setValues({
      ...values,
      lunchHours: {
        ...values.lunchHours,
        [day]: {
          ...values.lunchHours[day],
          [field]: value,
        },
      },
    });
  };

  const handleChangeDinnerHours = (day, field, value) => {
    setValues({
      ...values,
      dinnerHours: {
        ...values.dinnerHours,
        [day]: {
          ...values.dinnerHours[day],
          [field]: value,
        },
      },
    });
  };

  const handleChangeAllDayHours = (day, field, value) => {
    setValues({
      ...values,
      allDayHours: {
        ...values.allDayHours,
        [day]: {
          ...values.allDayHours[day],
          [field]: value,
        },
      },
    });
  };

  const handleChangePerpose = (day, field, value) => {
    setValues((prev) => ({
      ...prev,
      purpose: {
        ...prev.purpose,
        [day]: {
          ...(prev.purpose?.[day] || {}),
          [field]: value,
        },
      },
    }));
  };

  const handleSubmit = async (val) => {
    if (validator.current.allValid()) {
      values.profileImage = isProfileImageChange ? profileImage : "";
      values.mapImage = googleMapUrl;
      values.bannerImage = isBannerImageChange ? bannerImages : "";
      values.openBreakfast = openBreakfast === true ? "1" : "0";
      values.openLunch = openLunch === true ? "1" : "0";
      values.openDinner = openDinner === true ? "1" : "0";
      values.openAllDay = openAllDay === true ? "1" : "0";

      onSubmit(values, val);
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const getBannerImages = (banners) => {
    setBannerImages(banners);
    setIsBannerImageChange(true);
    setValues({ ...values, bannerImageUploaded: "uploaded" });
  };

  const getProfileImage = (img) => {
    setProfileImage(img);
    setIsProfileImageChange(true);
  };

  const getMapImage = (img) => {
    setMapImage(img);
    setIsMapImageChange(true);
  };

  const handleChangeState = (selected) => {
    setValues({ ...values, address: { ...values.address, state: selected } });
  };

  const handleChangePhone = (e) => {
    const inputValue = e.target.value; //handleNumericInput(e.target.value);
    // if (inputValue !== null && inputValue.length < 11) {
    //   setValues({
    //     ...values,
    //     phone: inputValue,
    //   });
    // }
    setValues({
      ...values,
      phone: inputValue,
    });
  };

  const handleSearchLocationId = async () => {
    if (values.locationId === "") {
      setLocationError(true);
    } else {
      setSearchLoading(true);
      const resp = await authCall("getGoogleRestaurantDetails", {
        locationId: values.locationId,
      });

      if (resp?.type === "success") {
        const restDetails = resp?.payload;
        addressComp(restDetails?.address_components, restDetails);
        setGoogleMapUrl(restDetails?.url);
        setSearchLoading(false);
      } else {
        setLocationError(false);
      }
    }
  };

  const addressComp = (addressComponents, restDetails) => {
    if (addressComponents) {
      // Extract subpremise
      const subpremise = addressComponents.find((component) =>
        component.types.includes("subpremise")
      )?.long_name;
      const isSubpremise = subpremise ? `${subpremise}/` : "";

      // Extract premise
      const premise = addressComponents.find((component) =>
        component.types.includes("premise")
      )?.long_name;
      const isPremise = premise ? `${premise},` : "";

      // Extract street address
      const street = addressComponents.find((component) =>
        component.types.includes("street_number")
      )?.long_name;

      // Extract route
      const route = addressComponents.find((component) =>
        component.types.includes("route")
      )?.long_name;

      // Extract political
      const city = addressComponents.find((component) =>
        component.types.includes("political")
      )?.short_name;

      // Extract state (administrative_area_level_1)
      const addressLong = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      )?.long_name;
      const addressShort = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      )?.long_name;
      const isAddress = {
        value: addressShort,
        label: addressLong,
      };

      // Extract postal code
      const postalCode = addressComponents.find((component) =>
        component.types.includes("postal_code")
      )?.long_name;

      const result = generateMealTimes(restDetails?.opening_hours);
      // console.log("vvv", result);
      setValues({
        ...values,
        name: restDetails?.name || "",
        phone: restDetails?.formatted_phone_number || "",
        totalRating: restDetails?.rating || 0,
        userTotalRating: restDetails?.user_ratings_total || 0,
        address: {
          streetName: route
            ? `${isPremise} ${isSubpremise}${street} ${route}`
            : "",
          city: city || "",
          state: isAddress || "",
          zipCode: postalCode || "",
        },
        latitude: restDetails?.geometry?.location?.lat,
        longitude: restDetails?.geometry?.location?.lng,
        breakFastHours: result.breakfast,
        lunchHours: result.lunch,
        dinnerHours: result.dinner,
        allDayHours: result.allDay,
        // website: restDetails?.website,
      });

      setOpenBreakfast(result.breakfast ? true : false);
      setOpenLunch(result.lunch ? true : false);
      setOpenDinner(result.dinner ? true : false);
      setOpenAllDay(result.allDay ? true : false);
    }
  };

  const handleFetchMap = () => {
    if (googleMapUrl === "") {
      setGoogleMapUrlError("The Google map url field is required.");
    } else {
      const regex = /^https:\/\/www\.google\.com\/maps\/embed\?.*pb=.*$/;
      if (!regex.test(googleMapUrl)) {
        setGoogleMapUrlError("Invalid Google map url.");
      } else {
        setGoogleMapUrlError("show");
      }
    }
  };

  ////////// opening hours ////////////////
  const generateMealTimes = (openingHours) => {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    if (openingHours.periods.length > 7) {
      const MEALTIMES = {
        allDay: null,
        breakfast: {},
        lunch: {},
        dinner: {},
      };

      const isBreakfastTime = (open) => open < "0900";
      const isLunchTime = (open, close) => open >= "0900" && open < "1400";
      const isDinnerTime = (close) => close >= "1600";

      daysOfWeek.forEach((day, index) => {
        const periods = openingHours.periods.filter(
          (p) => p.open.day === index
        );

        // Process Breakfast
        const breakfastPeriod = periods.find((p) =>
          isBreakfastTime(p.open.time)
        );
        MEALTIMES.breakfast[day] = breakfastPeriod
          ? {
              openningTime: `${breakfastPeriod.open.time.slice(
                0,
                2
              )}:${breakfastPeriod.open.time.slice(2)}`,
              closingTime: `${breakfastPeriod.close.time.slice(
                0,
                2
              )}:${breakfastPeriod.close.time.slice(2)}`,
              close: false,
            }
          : { openningTime: null, closingTime: null, close: true };

        // Process Lunch
        const lunchPeriod = periods.find((p) =>
          isLunchTime(p.open.time, p.close.time)
        );
        MEALTIMES.lunch[day] = lunchPeriod
          ? {
              openningTime: `${lunchPeriod.open.time.slice(
                0,
                2
              )}:${lunchPeriod.open.time.slice(2)}`,
              closingTime:
                lunchPeriod.close.time > "1600"
                  ? "16:00"
                  : `${lunchPeriod.close.time.slice(
                      0,
                      2
                    )}:${lunchPeriod.close.time.slice(2)}`,
              close: false,
            }
          : { openningTime: null, closingTime: null, close: true };

        // Process Dinner
        const dinnerPeriod = periods.find((p) => isDinnerTime(p.close.time));
        MEALTIMES.dinner[day] = dinnerPeriod
          ? {
              openningTime:
                dinnerPeriod.open.time < "1600"
                  ? "16:00"
                  : `${dinnerPeriod.open.time.slice(
                      0,
                      2
                    )}:${dinnerPeriod.open.time.slice(2)}`,
              closingTime: `${dinnerPeriod.close.time.slice(
                0,
                2
              )}:${dinnerPeriod.close.time.slice(2)}`,
              close: false,
            }
          : { openningTime: null, closingTime: null, close: true };
      });

      return MEALTIMES;
    } else {
      const MEALTIMES2 = {
        allDay: {},
        breakfast: null,
        lunch: null,
        dinner: null,
      };

      daysOfWeek.forEach((day, index) => {
        const periods = openingHours.periods.filter(
          (p) => p.open.day === index
        );
        const alldaytime = periods.length > 0 ? periods[0] : null;
        MEALTIMES2.allDay[day] = alldaytime
          ? {
              openningTime: `${alldaytime.open.time.slice(
                0,
                2
              )}:${alldaytime.open.time.slice(2)}`,
              closingTime: `${alldaytime.close.time.slice(
                0,
                2
              )}:${alldaytime.close.time.slice(2)}`,
              close: false,
            }
          : { openningTime: null, closingTime: null, close: true };
      });

      return MEALTIMES2;
    }
  };

  const handleChangeDiataries = (e) => {
    const { value, checked } = e.target;
    setValues((prevValues) => {
      const currentDietaries = prevValues?.dietaries || [];

      return {
        ...prevValues,
        dietaries: checked
          ? [...currentDietaries, value]
          : currentDietaries.filter((v) => v !== value),
      };
    });
  };

  return (
    <>
      {/* {console.log("values", values)} */}
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <Sidebar details={details} />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">{heading}</div>
                <div className="details-wrapper">
                  <div className="sub-title mb-3">
                    These details will appear on your activity listing
                  </div>

                  {/* Restaurant Details */}
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div className="main-heading2 mb-3">
                          Restaurant Details:
                        </div>
                        {/* location id */}
                        <div className="row gx-3 d-flex flex-wrap align-items-center mb-2">
                          <div className="col-6">
                            <label
                              htmlFor="RestaurantName"
                              className="fs-md-18 mb-1"
                            >
                              Google Place ID:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="locationId"
                              placeholder=""
                              autoComplete="off"
                              name="locationId"
                              value={values.locationId}
                              onChange={handleChange}
                            />
                            <Link
                              className="fs-12"
                              to="https://developers.google.com/maps/documentation/places/web-service/place-id"
                              target="_blank"
                            >
                              Enter google place id and get restaurant details
                              from google
                            </Link>
                            {/* <span className="fs-12">
                              <i>
                                Enter google place id and get restaurant details
                                from google
                              </i>
                            </span> */}
                            {locationError && (
                              <div class="srv-validation-message">
                                The location id field is required.
                              </div>
                            )}
                          </div>
                          <div className="col-6">
                            <button
                              type="button"
                              className="btn btn-custom btn-custom-sm1"
                              style={{ fontSize: 18, minHeight: 40 }}
                              onClick={handleSearchLocationId}
                              disabled={searchLoading || false}
                            >
                              {searchLoading ? "Searching..." : "Search"}
                            </button>
                          </div>
                        </div>
                        <div className="row gx-3 d-flex flex-wrap align-items-center mb-2">
                          <div className="col-6">
                            <label
                              htmlFor="RestaurantName"
                              className="fs-md-18 mb-1"
                            >
                              Restaurant Name:
                              <span className="text-red">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="RestaurantName"
                              placeholder=""
                              autoComplete="off"
                              name="name"
                              value={values.name}
                              onChange={handleChange}
                            />
                            {validator.current.message(
                              "restaurant name",
                              values.name,
                              "required"
                            )}
                          </div>
                          {/* phone */}
                          <div className="col-6">
                            <label
                              htmlFor="RestaurantPhone"
                              className="fs-md-18 mb-1"
                            >
                              Restaurant Phone:
                            </label>
                            {/* <input
                              type="text"
                              className="form-control"
                              id="RestaurantPhone"
                              placeholder=""
                              autoComplete="off"
                              value={values.phone}
                              name="phone"
                              onChange={handleChangePhone}
                            /> */}

                            <InputMask
                              mask="(99) 9999-9999"
                              value={values.phone}
                              onChange={handleChangePhone}
                              placeholder=""
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="row gx-3 d-flex flex-wrap align-items-center mb-2">
                          <div className="col-6">
                            <label
                              htmlFor="RestaurantName"
                              className="fs-md-18 mb-1"
                            >
                              Booking URL:
                              {/* <span className="text-red">*</span> */}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="booking_url"
                              placeholder=""
                              autoComplete="off"
                              name="bookingUrl"
                              value={values.bookingUrl}
                              onChange={handleChange}
                            />
                            {/* {validator.current.message(
                              "website",
                              values.website,
                              "required"
                            )} */}
                          </div>
                        </div>

                        {/* DIETITIONS */}
                        <div className="row mt-4">
                          {DIETS.map((el, index) => (
                            <div
                              key={index}
                              className={`col-6 col-xl-${
                                el === "Gluten Free"
                                  ? 2
                                  : el === "Vegan"
                                  ? 2
                                  : 2
                              }`}
                            >
                              <div className="fs-md-18 d-flex mb-3 gap-2">
                                <input
                                  type="checkbox"
                                  name={el}
                                  value={el}
                                  checked={values?.dietaries.includes(el)}
                                  onChange={handleChangeDiataries}
                                />
                                <label>{el}</label>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* RESTURANT VALUES */}
                        <div className="row mt-2">
                          {RESTAURANTVALUES.map((el, index) => (
                            <div key={index} className={`col-6 col-xl-2`}>
                              <div className="fs-md-18 d-flex mb-3 gap-2">
                                <input
                                  type="radio"
                                  className="custom-radio m-0 companyType cursor-pointer"
                                  name={el}
                                  value={el}
                                  checked={
                                    values?.restaurantValue === el || false
                                  }
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      restaurantValue: e.target.value,
                                    })
                                  }
                                />
                                <label>{el}</label>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* PURPOSE */}
                        {(current?.user_type === "Admin" ||
                          current?.user_type === "Super Admin") && (
                          <div className="row mt-2">
                            <div className="col-12">
                              <div className="info-cover pb-lg-2">
                                <div className="col-12">
                                  <div className="info-cover breakfast-timing">
                                    <div className="main-heading23 fs-md-18 d-flex gap-1">
                                      Purposes:
                                    </div>
                                    <>
                                      <div className="title-cover">
                                        <div className="row">
                                          <div className="col-3 mb-1">
                                            &nbsp;
                                          </div>
                                          <div className="col-2 d-flex gap-3">
                                            <div className="fs-14 fw-semibold flex-fill">
                                              Family
                                            </div>
                                          </div>
                                          <div className="col-2 d-flex gap-3">
                                            <div className="fs-14 fw-semibold flex-fill">
                                              Popular
                                            </div>
                                          </div>
                                          <div className="col-2 d-flex gap-3">
                                            <div className="fs-14 fw-semibold flex-fill">
                                              Meeting
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {Object.entries(PURPOSES).map(
                                        ([day, perp, index]) => (
                                          <div
                                            key={index}
                                            className="day-cover row"
                                          >
                                            <div className="col-3 mb-1">
                                              {day}:
                                            </div>

                                            <div className="col-2 d-flex gap-3">
                                              <div className="flex-fill mb-2">
                                                <input
                                                  style={{ marginTop: 5 }}
                                                  type="checkbox"
                                                  className="custom-radio1"
                                                  checked={
                                                    values?.purpose?.[day]
                                                      ?.family || false
                                                  }
                                                  onChange={(e) =>
                                                    handleChangePerpose(
                                                      day,
                                                      "family",
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>

                                            <div className="col-2 d-flex gap-3">
                                              <div className="flex-fill mb-2">
                                                <input
                                                  style={{ marginTop: 5 }}
                                                  type="checkbox"
                                                  className="custom-radio1"
                                                  checked={
                                                    values?.purpose?.[day]
                                                      ?.popular || false
                                                  }
                                                  onChange={(e) =>
                                                    handleChangePerpose(
                                                      day,
                                                      "popular",
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>

                                            <div className="col-2 d-flex gap-3">
                                              <div className="flex-fill mb-2">
                                                <input
                                                  style={{ marginTop: 5 }}
                                                  type="checkbox"
                                                  className="custom-radio1"
                                                  checked={
                                                    values?.purpose?.[day]
                                                      ?.meeting || false
                                                  }
                                                  onChange={(e) =>
                                                    handleChangePerpose(
                                                      day,
                                                      "meeting",
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Restaurant Address */}
                  <div className="row">
                    <div className="col-12">
                      <div className="location-details-page info-cover mb-2 pb-lg-3">
                        <label
                          htmlFor="RestaurantPhone"
                          className="fs-md-18 mb-1"
                        >
                          Restaurant Address :
                        </label>
                        <div className="address-wrapper">
                          <div className="row gx-3">
                            <div className="col-12">
                              <div className="form-group">
                                <label
                                  className="fs-14 fw-medium"
                                  htmlFor="address1"
                                >
                                  Address Line 1{" "}
                                  <span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="address1"
                                  placeholder=""
                                  autoComplete="off"
                                  name="address.streetName"
                                  value={values.address.streetName}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label
                                  className="fs-14 fw-medium"
                                  htmlFor="city"
                                >
                                  City <span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="city"
                                  placeholder=""
                                  autoComplete="off"
                                  name="address.city"
                                  value={values.address.city}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group">
                                <label
                                  className="fs-14 fw-medium"
                                  htmlFor="State"
                                >
                                  State <span className="text-red">*</span>
                                </label>
                                <Select
                                  className="text-body"
                                  styles={customStyles}
                                  placeholder="Select State"
                                  value={values?.address?.state}
                                  name="address.state"
                                  onChange={handleChangeState}
                                  options={states}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group mb-2">
                                <label
                                  className="fs-14 fw-medium"
                                  htmlFor="zipcode"
                                >
                                  Post Code <span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="zipcode"
                                  placeholder=""
                                  autoComplete="off"
                                  maxLength="6"
                                  name="address.zipCode"
                                  value={values.address.zipCode}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group mb-2">
                                <label
                                  className="fs-14 fw-medium"
                                  htmlFor="zipcode"
                                >
                                  Latitude <span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="zipcode"
                                  placeholder=""
                                  autoComplete="off"
                                  maxLength="6"
                                  name="latitude"
                                  value={values.latitude}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4">
                              <div className="form-group mb-2">
                                <label
                                  className="fs-14 fw-medium"
                                  htmlFor="zipcode"
                                >
                                  Longitude <span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="zipcode"
                                  placeholder=""
                                  autoComplete="off"
                                  maxLength="6"
                                  name="longitude"
                                  value={values.longitude}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Houres */}
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div className="main-heading2 mb-3">Hours:</div>
                        {/* Breakfast hours */}
                        <div className="col-12">
                          <div className="info-cover breakfast-timing">
                            <div
                              className="main-heading23 fs-md-18 d-flex mb-3 gap-1"
                              style={{ color: openAllDay ? "#ffffff47" : "" }}
                            >
                              Open for Breakfast?:{" "}
                              <input
                                style={{
                                  marginTop: 4,
                                  backgroundColor: openAllDay
                                    ? "#808080a8"
                                    : "",
                                }}
                                type="checkbox"
                                className="custom-radio1"
                                checked={openBreakfast}
                                onChange={(e) =>
                                  setOpenBreakfast(e.target.checked)
                                }
                                disabled={openAllDay}
                              />
                            </div>
                            {openBreakfast && (
                              <>
                                <div className="title-cover">
                                  <div className="row">
                                    <div className="col-3 mb-1">&nbsp;</div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Opening Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Closing Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Close?
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {Object.entries(values.breakFastHours).map(
                                  ([day, hours, index]) => (
                                    <div key={index} className="day-cover row">
                                      <div className="col-3 mb-1">{day}:</div>
                                      {hours.close === false ? (
                                        <>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                autoComplete="off"
                                                value={hours.openningTime}
                                                onChange={(e) =>
                                                  handleChangeHours(
                                                    day,
                                                    "openningTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={hours.closingTime}
                                                autoComplete="off"
                                                onChange={(e) =>
                                                  handleChangeHours(
                                                    day,
                                                    "closingTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className="col-6 d-flex justify-content-center"
                                          style={{
                                            color: "red",
                                            placeItems: "center1",
                                          }}
                                        >
                                          Closed
                                        </div>
                                      )}
                                      <div className="col-3 d-flex gap-3">
                                        <div className="flex-fill mb-2">
                                          <input
                                            style={{ marginTop: 5 }}
                                            type="checkbox"
                                            className="custom-radio1"
                                            value={hours.close}
                                            checked={hours.close}
                                            onChange={(e) =>
                                              handleChangeHours(
                                                day,
                                                "close",
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Lunch Hours */}
                        <div className="col-12 mt-3">
                          <div className="info-cover breakfast-timing">
                            <div
                              className="main-heading23 fs-md-18 d-flex mb-3 gap-1"
                              style={{ color: openAllDay ? "#ffffff47" : "" }}
                            >
                              Open for Lunch?:
                              <input
                                style={{
                                  marginTop: 4,
                                  backgroundColor: openAllDay
                                    ? "#808080a8"
                                    : "",
                                }}
                                type="checkbox"
                                className="custom-radio1"
                                checked={openLunch}
                                onChange={(e) => setOpenLunch(e.target.checked)}
                                disabled={openAllDay}
                              />
                            </div>
                            {openLunch && (
                              <>
                                <div className="title-cover">
                                  <div className="row">
                                    <div className="col-3 mb-1">&nbsp;</div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Opening Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Closing Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Close?
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {Object.entries(values.lunchHours).map(
                                  ([day, hours, index]) => (
                                    <div key={index} className="day-cover row">
                                      <div className="col-3 mb-1">{day}:</div>
                                      {hours.close === false ? (
                                        <>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                autoComplete="off"
                                                value={hours.openningTime}
                                                onChange={(e) =>
                                                  handleChangeLunchHours(
                                                    day,
                                                    "openningTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={hours.closingTime}
                                                autoComplete="off"
                                                onChange={(e) =>
                                                  handleChangeLunchHours(
                                                    day,
                                                    "closingTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className="col-6 d-flex justify-content-center"
                                          style={{
                                            color: "red",
                                            placeItems: "center1",
                                          }}
                                        >
                                          Closed
                                        </div>
                                      )}
                                      <div className="col-3 d-flex gap-3">
                                        <div className="flex-fill mb-2">
                                          <input
                                            style={{ marginTop: 5 }}
                                            type="checkbox"
                                            className="custom-radio1"
                                            value={hours.close}
                                            checked={hours.close}
                                            onChange={(e) =>
                                              handleChangeLunchHours(
                                                day,
                                                "close",
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Dinner Hours */}
                        <div className="col-12 mt-3">
                          <div className="info-cover breakfast-timing">
                            <div
                              className="main-heading23 fs-md-18 d-flex mb-3 gap-1"
                              style={{ color: openAllDay ? "#ffffff47" : "" }}
                            >
                              Open for Dinner?:
                              <input
                                style={{
                                  marginTop: 4,
                                  backgroundColor: openAllDay
                                    ? "#808080a8"
                                    : "",
                                }}
                                type="checkbox"
                                className="custom-radio1"
                                checked={openDinner}
                                onChange={(e) =>
                                  setOpenDinner(e.target.checked)
                                }
                                disabled={openAllDay}
                              />
                            </div>
                            {openDinner && (
                              <>
                                <div className="title-cover">
                                  <div className="row">
                                    <div className="col-3 mb-1">&nbsp;</div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Opening Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Closing Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Close?
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {Object.entries(values.dinnerHours).map(
                                  ([day, hours, index]) => (
                                    <div key={index} className="day-cover row">
                                      <div className="col-3 mb-1">{day}:</div>
                                      {hours.close === false ? (
                                        <>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                autoComplete="off"
                                                value={hours.openningTime}
                                                onChange={(e) =>
                                                  handleChangeDinnerHours(
                                                    day,
                                                    "openningTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={hours.closingTime}
                                                autoComplete="off"
                                                onChange={(e) =>
                                                  handleChangeDinnerHours(
                                                    day,
                                                    "closingTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className="col-6 d-flex justify-content-center"
                                          style={{
                                            color: "red",
                                            placeItems: "center1",
                                          }}
                                        >
                                          Closed
                                        </div>
                                      )}
                                      <div className="col-3 d-flex gap-3">
                                        <div className="flex-fill mb-2">
                                          <input
                                            style={{ marginTop: 5 }}
                                            type="checkbox"
                                            className="custom-radio1"
                                            value={hours.close}
                                            checked={hours.close}
                                            onChange={(e) =>
                                              handleChangeDinnerHours(
                                                day,
                                                "close",
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Same menu all day */}
                        <div className="col-12 mt-3">
                          <div className="info-cover breakfast-timing">
                            <div
                              className="main-heading23 fs-md-18 d-flex mb-3 gap-1"
                              style={{
                                color:
                                  openBreakfast || openLunch || openDinner
                                    ? "#ffffff47"
                                    : "",
                              }}
                            >
                              Same Menu all Day?:
                              <input
                                style={{
                                  marginTop: 4,
                                  backgroundColor:
                                    openBreakfast || openLunch || openDinner
                                      ? "#808080a8"
                                      : "",
                                }}
                                type="checkbox"
                                className="custom-radio1"
                                checked={openAllDay}
                                onChange={(e) =>
                                  setOpenAllDay(e.target.checked)
                                }
                                disabled={
                                  openBreakfast || openLunch || openDinner
                                }
                              />
                            </div>
                            {openAllDay && (
                              <>
                                <div className="title-cover">
                                  <div className="row">
                                    <div className="col-3 mb-1">&nbsp;</div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Opening Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Closing Time
                                      </div>
                                    </div>
                                    <div className="col-3 d-flex gap-3">
                                      <div className="fs-14 fw-semibold flex-fill">
                                        Close?
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {Object.entries(values.allDayHours).map(
                                  ([day, hours, index]) => (
                                    <div key={index} className="day-cover row">
                                      <div className="col-3 mb-1">{day}:</div>
                                      {hours.close === false ? (
                                        <>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                autoComplete="off"
                                                value={hours.openningTime}
                                                onChange={(e) =>
                                                  handleChangeAllDayHours(
                                                    day,
                                                    "openningTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="col-3 d-flex gap-3">
                                            <div className="flex-fill mb-2">
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={hours.closingTime}
                                                autoComplete="off"
                                                onChange={(e) =>
                                                  handleChangeAllDayHours(
                                                    day,
                                                    "closingTime",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className="col-6 d-flex justify-content-center"
                                          style={{
                                            color: "red",
                                            placeItems: "center1",
                                          }}
                                        >
                                          Closed
                                        </div>
                                      )}
                                      <div className="col-3 d-flex gap-3">
                                        <div className="flex-fill mb-2">
                                          <input
                                            style={{ marginTop: 5 }}
                                            type="checkbox"
                                            className="custom-radio1"
                                            value={hours.close}
                                            checked={hours.close}
                                            onChange={(e) =>
                                              handleChangeAllDayHours(
                                                day,
                                                "close",
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {validator.current.message(
                          "meal selection",
                          openBreakfast || openLunch || openDinner,
                          "required"
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="field-wrapper mb-lg-2">
                    <div className="info-cover">
                      <div className="row">
                        <div className="col-12">
                          <div className="main-heading2 mb-1">Images:</div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                          <div className="info-cover">
                            <div className="profile-cover mb-3">
                              <div className="main-heading2 text-white mb-1">
                                Profile Images:
                              </div>
                              <p className="fs-12">
                                <i>
                                  (This is the image shown on the search results
                                  page)
                                </i>
                              </p>
                              <ImageUploads
                                getImage={getProfileImage}
                                uploadedImage={profileImage}
                                aspectRation={1}
                                croppedSize={{
                                  width: 870,
                                  height: 580,
                                  imageSmoothingQuality: "high",
                                }}
                                index={1}
                              />
                              <div
                                style={{
                                  marginTop: !profileImage ? "-5px" : 0,
                                }}
                              >
                                {validator.current.message(
                                  "profile image",
                                  profileImage,
                                  "required"
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="info-cover">
                            <BannerImagesUploads
                              bannerImages={getBannerImages}
                              images={bannerImages}
                            />
                            {validator.current.message(
                              "banner",
                              values.bannerImageUploaded,
                              "required"
                            ) && (
                              <div
                                style={{
                                  marginTop: "-38px",
                                }}
                              >
                                {validator.current.message(
                                  "banner",
                                  values.bannerImageUploaded,
                                  "required"
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {googleMapUrl && (
                    <div className="row">
                      <div className="col-12">
                        <div className="info-cover pb-lg-2">
                          {/* location id */}
                          <div className="row gx-3 d-flex flex-wrap align-items-center mb-2">
                            <div className="col-6">
                              <label
                                htmlFor="RestaurantName"
                                className="fs-md-18 mb-1"
                              >
                                Google Maps:
                              </label>
                              <div className="col-6">
                                <div
                                  style={{
                                    // height: "65vh",
                                    overflow: "hidden",
                                    position: "relative",
                                    // width: "100%",
                                    width: "450px",
                                    height: "250px",
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: 2,
                                    border: "2px solid #fff",
                                    borderRadius: 15,
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: 0,
                                      height: "100%",
                                      width: "calc(100vw + 600px)",
                                    }}
                                  >
                                    <iframe
                                      class="border-card"
                                      src={`${googleMapUrl}&output=embed`}
                                      width="100%"
                                      height="100%"
                                      allowfullscreen=""
                                      loading="lazy"
                                    ></iframe>
                                  </div>
                                </div>
                              </div>
                              {/* <input
                              type="text"
                              className="form-control"
                              id="googleMap"
                              placeholder=""
                              autoComplete="off"
                              name="googleMap"
                              value={googleMapUrl}
                              onChange={(e) => {
                                setGoogleMapUrl(e.target.value);
                                setGoogleMapUrlError("");
                              }}
                            />
                            <Link
                              className="fs-12"
                              to="https://www.google.com/maps/preview?hl=en"
                              target="_blank"
                            >
                              Google map url
                            </Link>

                            {googleMapUrlError !== "show" &&
                              googleMapUrlError !== "" && (
                                <div class="srv-validation-message">
                                  {googleMapUrlError}
                                </div>
                              )} */}
                            </div>
                            {/* <div className="col-6">
                            <button
                              type="button"
                              className="btn btn-custom btn-custom-sm1"
                              style={{ fontSize: 18, minHeight: 40 }}
                              onClick={handleFetchMap}
                              disabled={mapLoading || false}
                            >
                              {mapLoading ? "Fetching..." : "Show Map"}
                            </button>
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="wrapper mb-2">
                    <div className="info-cover">
                      <div className="btn-wrapper d-flex flex-column flex-md-row flex-wrap justify-content-center row-gap-3 column-gap-4 mt-4">
                        {buttons.map((button) => (
                          <button
                            key={button.id}
                            onClick={() => handleSubmit(button.type)}
                            className="btn btn-custom"
                            disabled={loading || false}
                          >
                            {loading ? "Loading..." : button.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* {admin ? (
                      <div className="wrapper mb-2">
                        <div className="info-cover">
                          <div className="btn-wrapper d-flex flex-column flex-md-row flex-wrap justify-content-center row-gap-3 column-gap-4 mt-4">
                            <button
                              type="button"
                              className="btn btn-custom"
                              onClick={handleSubmit}
                              disabled={loading || false}
                            >
                              {loading ? "Updating..." : "Update"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="wrapper mb-2">
                        <div className="info-cover">
                          <div className="btn-wrapper d-flex flex-column flex-md-row flex-wrap justify-content-center row-gap-3 column-gap-4 mt-4">
                            <button
                              type="button"
                              className="btn btn-custom"
                              onClick={() => handleSubmit("breakFast")}
                              disabled={loading || false}
                            >
                              {loading ? "Submitting..." : "Add Breakfast Menu"}
                            </button>

                            <button
                              type="button"
                              className="btn btn-custom"
                              onClick={() => handleSubmit("lunch")}
                              disabled={loading || false}
                            >
                              {loading ? "Submitting..." : "Add Lunch Menu"}
                            </button>

                            <button
                              type="button"
                              className="btn btn-custom"
                              onClick={() => handleSubmit("dinner")}
                              disabled={loading || false}
                            >
                              {loading ? "Submitting..." : "Add Dinner Menu"}
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RestaurantDetailPage;
